import { createPaginatedSlice } from '../../../helpers/reduxHelper';

const paginatedAutomationDetails = createPaginatedSlice('paginatedAutomation', {
  pagination: 'normal',
});

export const paginatedAutomationDetailsActions = paginatedAutomationDetails.actions;
export const paginatedAutomationDetailsSelector = (state) => state.paginatedAutomationDetails;
export const paginatedAutomationDetailsReducer = paginatedAutomationDetails.reducer;
export default paginatedAutomationDetailsReducer;

export const paginatedAutomationSelectors = paginatedAutomationDetails.LF.selectors;
